import React, { useContext, useEffect, useState } from 'react';
import NavBar from 'components/utils/NavBar';
import TitleBar from 'components/utils/TitleBar';
import styles from './styles.module.css';
import Loader from 'components/utils/Loading';
import { SHOP_STATUS, STORAGE_KEYS } from 'const';
import { selectedTabContext } from 'Context/SelectedTabContext';
import { ThemeContext } from 'Context/ThemeContext';
import { ShopContext } from 'Context/ShopContext';
import { UserContext } from 'Context/UserContext';
import SubscriptionEndPopup from 'components/popups/SubscriptionEndPopup';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import ShopDeleteConfirmationPopup from 'components/popups/ShopDeleteConfirmationPopup';
import ShopsHelper from 'helpers/ShopsHelper';
import Adbox from 'components/utils/Adbox/Adbox';

function withConsoleBase(ConsoleComponent) {
  return (props) => {
    const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
    const { isMenuOpen, selectedTab } = useContext(selectedTabContext);
    const { theme } = useContext(ThemeContext);
    const { shop } = useContext(ShopContext);
    const { user } = useContext(UserContext);

    const [isShowSubscriptionEndPopup, setIsShowSubscriptionEndPopup] = useState(false);

    useEffect(() => {
      if (shop) {
        const isExpired = DateTimeHelpers.isDatePassed(shop.subscription_end_date);
        const isAllowedPage = window.location.pathname.includes('renew-plan');

        if (isExpired && !isAllowedPage) {
          setIsShowSubscriptionEndPopup(true);
        } else {
          setIsShowSubscriptionEndPopup(false);
        }
      }
    }, [shop, selectedTab]);

    return (
      <>
        {shopId !== '-1' ? (
          <>
            <div className={styles.MainLayoutWrapper}>
              <div
                className={`${styles.ContentsWrapper} ${
                  shop && ShopsHelper.isAdSupportedPlan(shop) ? styles.ContentsWrapperWithAd : ''
                }`}
              >
                <TitleBar />
                <div className={styles.ContentsInner}>
                  {shop?.status === SHOP_STATUS.DELETE_REQUESTED ? (
                    <ShopDeleteConfirmationPopup shop={shop} handleClose={() => {}} />
                  ) : isShowSubscriptionEndPopup ? (
                    <SubscriptionEndPopup />
                  ) : (
                    <>
                      <div
                        style={{ backgroundColor: theme.color.primary }}
                        className={isMenuOpen ? styles.NavbarWrapperOpen : styles.NavbarWrapper}
                      >
                        <NavBar />
                      </div>
                      <div className={styles.ContentsArea}>
                        <div className={styles.ContentsView}>
                          {shop && user ? <ConsoleComponent /> : <Loader isOpen={true} />}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {shop && ShopsHelper.isAdSupportedPlan(shop) && (
                <div className={styles.AdboxWrapperViewport}>
                  <Adbox />
                </div>
              )}
            </div>
          </>
        ) : (
          <Loader isOpen={true} />
        )}
      </>
    );
  };
}

export default withConsoleBase;
